<template>
  <div
    class="bg-white border border-gray-200 mb-10 rounded-xl xl:grid xl:grid-cols-3 gap-8"
  >
    <div class="p-4 md:p-6 lg:p-8 pt-3 md:pt-5 lg:pt-6 bg-gray-50 rounded-tr-xl rounded-tl-xl xl:rounded-tr-none xl:rounded-l-xl col-span-1 border-b xl:border-b-0 xl:border-r">
       <div
          v-if="hasHeaderSlot"
        >
        <span class="font-body mb-4 inline-block">
          <slot name="header"></slot>
        </span>
      </div>
      <slot name="form"></slot>
    </div>
    <div class="p-4 pt-8 md:p-6 lg:p-8 xl:pl-0 md:pt-5 lg:pt-6 col-span-2">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
  },
  computed: {
    hasHeaderSlot () {
      return !!this.$slots.header
    },
  },
  setup() {

  },
}
</script>
